import moment from 'moment';
import { FilterOrderParams } from 'pages/historisation';
import { useEffect } from 'react';
import {
  CommunicationsHistoryForm,
  HistoricCommunication,
  PublicStation,
  SendStatus,
  ServiceType,
  Situation,
} from 'types';

export interface Props {
  data?: HistoricCommunication;
  originStations?: PublicStation[];
  senders: string[];
  sendStatutes: SendStatus[];
  circulationValues?: { serviceName?: string; circulationDate?: string };
  filterOrder?: FilterOrderParams;
  situations?: Situation[];
  isCommunicationHistoryModalVisible: boolean;
  actifUserServiceTypes: ServiceType[];
  setFilterValues: (values: CommunicationsHistoryForm) => void;
  setFilterOrder: ({ name, order }: FilterOrderParams) => void;
}

export type FormValues = Omit<
  CommunicationsHistoryForm,
  'pageNumber' | 'maxResultPage' | 'parameterToSort' | 'ascDesc'
>;

interface RefreshDependencies {
  pageNumber: number;
  isModalVisible: boolean;
}

type DateValue = string | Date | undefined | null;

export const useRefreshEffect = (
  onRefresh: () => void,
  { pageNumber, isModalVisible }: RefreshDependencies,
  refreshInterval: number
) => {
  useEffect(() => {
    if (pageNumber !== 1 || isModalVisible) return;

    const intervalId = setInterval(onRefresh, refreshInterval);
    return () => clearInterval(intervalId);
  }, [onRefresh, pageNumber, isModalVisible, refreshInterval]);
};

export const formatDate = (date: DateValue): string | undefined => {
  return date ? moment(date).format('YYYY-MM-DD') : undefined;
};

export const shoudHaveDates = (formikValues: FormValues) => {
  return (
    !formikValues.communicationStartDate &&
    !formikValues.communicationEndDate &&
    !formikValues.departureTime &&
    !formikValues.arrivalTime
  );
};
